// src/utils/resumeAnalysisUtils.ts

/**
 * Resume Analysis Data Schema
 * Based on the actual backend response structure
 */

export interface BasicInfo {
  name: string;
  email: string;
  phone: string;
  location: string;
}

export interface Skill {
  name: string;
  category: string;
  relevance: number;
}

export interface Experience {
  title: string;
  company: string;
  start_date: string;
  end_date: string;
  description: string;
  key_achievements: string[];
}

export interface Education {
  institution: string;
  degree: string;
  field: string;
  graduation_date: string;
}

export interface Certification {
  name: string;
  issuer: string;
  date: string;
}

export interface NextSearchTarget {
  role: string;
  location: string;
  search_query: string;
}

export interface TokenUsage {
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
}

export interface ResumeAnalysisData {
  basic_info: BasicInfo;
  skills: Skill[];
  experience: Experience[];
  education: Education[];
  certifications: Certification[];
  summary: string;
  next_search_target: NextSearchTarget;
  user_id: string;
  analyzed_at: string;
  ai_provider: string;
  ai_model: string;
  token_usage: TokenUsage;
}

/**
 * Helper functions for resume analysis data
 */

export const getContactInfo = (data: ResumeAnalysisData) => {
  return {
    name: data.basic_info?.name,
    email: data.basic_info?.email,
    phone: data.basic_info?.phone,
    location: data.basic_info?.location,
  };
};

export const getTechnicalSkills = (data: ResumeAnalysisData) => {
  return data.skills?.filter(skill => skill.category === 'technical') || [];
};

export const getAllSkills = (data: ResumeAnalysisData) => {
  return data.skills || [];
};

export const getFormattedExperience = (data: ResumeAnalysisData) => {
  return data.experience || [];
};

export const getFormattedEducation = (data: ResumeAnalysisData) => {
  return data.education || [];
};

export const getFormattedCertifications = (data: ResumeAnalysisData) => {
  return data.certifications || [];
};